define('responsive-gameday/views/distributors/viewDistributors/ChyronDistributor',['require','exports','module','jquery','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','gameday-index-url-hasher/UrlHasher'],function(require,exports,module) {
	var $ = require("jquery"),
		ViewDistributorClass = require("./ViewDistributorBase"),
		UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
		MessageService = require("message-service/message-service"),
		DistEvents = require("../events/DistributionEvents"),
		exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
		GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates"),
		ordainedNum = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
		UrlHasher = require('gameday-index-url-hasher/UrlHasher');

	var Superclass,
		TOP 	= "Top",
		BOTTOM 	= "Bottom",
		ACTIVE 	= "active",
		EMPTY 	= "",
		MODE_INNING="inning",
        MODE_MIDINNING="midInning",
        MODE_FINAL="final",
        MODE_PREGAME="pregame",
        MODE_DELAYED="delay";


	function ChyronDataPack(game){
        var live = game.liveData,
        	play = game.getCurrentPlay();


        this.linescore = $.extend({},live.linescore);
        this.linescore.status=game.gameData.status;

		buildPitchers(this, game);
		buildTeams(this, game);
		buildStatus(this, game);
		buildBSO(this, play);
		buildUpNext(this, game);
		buildRunners(this, game);
		buildMatchup(this, live, play);
		determineRenderMode(this,game);
		// console.info('ChyronDistributor', this);

	}

	ChyronDataPack.prototype.mugshot = function(){
		return resourcePath.get('mugshot',{ pid : this.id});
	};

	ChyronDataPack.prototype.currentTop = function () {
		return this.inningHalf === TOP ? ACTIVE : EMPTY;
	};

	ChyronDataPack.prototype.currentBottom = function () {
		return this.inningHalf === BOTTOM ? ACTIVE : EMPTY;
	};

	ChyronDataPack.prototype.state = function() {
		return this.inningState !== EMPTY ? (this.inningState + " " + this.currentInningOrdinal) : this.status.detailedState;
	};
	ChyronDataPack.prototype.stateShort = function() {
		return this.inningState !== EMPTY ? (this.inningState.substr(0,3) + " " + this.currentInningOrdinal) : this.status.detailedState;
	};


	function ChyronDistributor(evt) {
		Superclass.constructor.call(this, evt);

		MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
		MessageService.addListener.call(this, UpdateEvents.REQUEST_CHYRON_DATA, this.handleUpdateRequest);
	}

	ViewDistributorClass.spawn(ChyronDistributor).define({
		prepDataForView: function() {
			this.dataPack = new ChyronDataPack(this.game);
			this.dispatchUpdates();
		}
	});

	
	function buildStatus(dataPack, game) {
		var status = game.gameData.status,
			linescore = dataPack.linescore;
		// dataPack.game = {};

		// dataPack.game.gameDelayed = ((status.abstractGamestate === GameStates.ABSTRACT_DELAYED) || (status.abstractGamestate === GameStates.ABSTRACT_OTHER));

		if (exists(status.challenge, "challengingTeam") && status.statusCode.charAt(0) === "M") {
			dataPack.status.gamestate = dataPack.play.challenging_team + " Challenge";
		}
	}

	function buildTeams(dataPack, game) {
		var teams = game.gameData.teams;

		// dataPack.home = $.extend({},gameInfo.home) || {};
		// dataPack.away = $.extend({},gameInfo.away) || {};
		dataPack.teams = {
			home: teams.home,
			away: teams.away
		};
	}

	function buildMatchup(dataPack, live, play) {
		var batterPitcher = exists(play, 'matchup' ) ? play.matchup : live.players.offense;
		dataPack.matchup = {
			batter: batterPitcher.batter,
			pitcher: batterPitcher.pitcher,
			deck: dataPack.upnext.deck,
			hole: dataPack.upnext.hole
		};
	}

	function buildBSO(dataPack, play) {
		var counts 	= play.count,
			balls 	= counts.balls * 1,
			strikes = counts.strikes * 1,
			outs 	= counts.outs * 1;

		dataPack.bso = {
			ball1: (balls >= 1) ? ACTIVE : EMPTY,
			ball2: (balls >= 2) ? ACTIVE : EMPTY,
			ball3: (balls >= 3) ? ACTIVE : EMPTY,
			ball4: (balls >= 4) ? ACTIVE : EMPTY,
			strike1: (strikes >= 1) ? ACTIVE : EMPTY,
			strike2: (strikes >= 2) ? ACTIVE : EMPTY,
			strike3: (strikes >= 3) ? ACTIVE : EMPTY,
			out1: (outs >= 1) ? ACTIVE : EMPTY,
			out2: (outs >= 2) ? ACTIVE : EMPTY,
			out3: (outs >= 3) ? ACTIVE : EMPTY
		}
	}

	function buildUpNext(dataPack, game) {
		var offense = game.liveData.players.offense;
		dataPack.upnext = {
			next: offense.batter,
			deck: offense.onDeck,
			hole: offense.inHole
		};
	}

	function buildRunners(dataPack, game) {
		var offense = game.liveData.players.offense;

		dataPack.runners = offense;
		dataPack.runnersMini= {
			first	: offense.first ? ACTIVE : EMPTY,
			second	: offense.second ? ACTIVE : EMPTY,
			third	: offense.third ? ACTIVE : EMPTY
		};
	}

	function buildPitchers(dataPack) {
		var pitchers = dataPack.linescore.pitchers;

		dataPack.pitchingDecisions = (exists(pitchers.win,'id') && exists(pitchers.loss,'id')) ? pitchers : null;
	}

	function determineRenderMode(dataPack, game) {
		var linescoreDebug = UrlHasher.getCachedParams().ls_state;
		var gamestate = linescoreDebug || game.gameData.status.abstractGameState;
		dataPack.renderMode={};

		switch (gamestate) {
			case GameStates.PREVIEW:
				dataPack.renderMode[MODE_PREGAME]=true;
				break;
			case GameStates.LIVE:
			 	var inningState = dataPack.linescore.inningState;
				if(inningState === "Mid" || inningState === "End"){
					dataPack.renderMode[MODE_MIDINNING]=true;
				}else{
					dataPack.renderMode[MODE_INNING]=true;
				}

				break;
			case GameStates.FINAL:
				dataPack.renderMode[MODE_FINAL]=true;

				break;
			case GameStates.DELAYED:
				dataPack.renderMode[MODE_DELAYED]=true;
				break;
		};
	}


	Superclass = ChyronDistributor.superclass;
	return ChyronDistributor;
});

